(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["per-grid-text-with-blog"] && !Shopify.designMode) return;
  try {
    
    (function($){
        $('ul.blogs').slick({
            infinite: true,
            autoplay: false,
            autoplaySpeed: 1000 * 5,
            speed: 500,
            arrows: true,
            dots: true,
            arrows: false
        });
    })(jQuery.noConflict());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["per-image-banner-slide"] && !Shopify.designMode) return;
  try {
    
    (function($){
        $('.per-image-banner-slide').slick({
            infinite: true,
            autoplay: false,
            autoplaySpeed: 1000 * 5,
            fade: true,
            speed: 500,
            cssEase: 'linear',
            arrows: true,
            dots: true,
            prevArrow: '.slick-prev',
            nextArrow: '.slick-next',
        });
    })(jQuery.noConflict());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["per-quotes"] && !Shopify.designMode) return;
  try {
    
    (function($){
        $('ul.quotes').slick({
            infinite: true,
            autoplay: false,
            autoplaySpeed: 1000 * 5,
            speed: 500,
            arrows: true,
            dots: true,
            arrows: false
        });
    })(jQuery.noConflict());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["per-slide-blog"] && !Shopify.designMode) return;
  try {
    
    (function($){
        $('ul.blog.enable_slide').slick({
            infinite: true,
            autoplay: false,
            autoplaySpeed: 1000 * 5,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 500,
            arrows: true,
            prevArrow: '.per-slide-blog .slider-button--prev',
            nextArrow: '.per-slide-blog .slider-button--next',
            dots: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    })(jQuery.noConflict());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["per-slide-coffee-notes"] && !Shopify.designMode) return;
  try {
    
    (function($){
        $('ul.coffee-notes.enable_slide').slick({
            infinite: true,
            autoplay: false,
            autoplaySpeed: 1000 * 5,
            slidesToShow: 4,
            slidesToScroll: 4,
            speed: 500,
            arrows: true,
            prevArrow: '.per-slide-coffee-notes .slider-button--prev',
            nextArrow: '.per-slide-coffee-notes .slider-button--next',
            dots: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    })(jQuery.noConflict());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["per-slide-product-pin"] && !Shopify.designMode) return;
  try {
    
    const scrollableDiv = document.querySelector('.media-slide.slider');

    scrollableDiv.addEventListener('scroll', () => {
        const elements = document.querySelectorAll('.slide-item');

        elements.forEach((element) => {
            addActiveClassToVisibleElement(element, scrollableDiv);
        });
    });

    function addActiveClassToVisibleElement(element, scrollableDiv) {
        if (isElementCompletelyVisible(element, scrollableDiv)) {
            element.classList.add('active');
        } else {
            element.classList.remove('active');
        }
    }

    function isElementCompletelyVisible(element, scrollableDiv) {
        const elementBoundingBox = element.getBoundingClientRect();
        const scrollableDivBoundingBox = scrollableDiv.getBoundingClientRect();

        return (
            elementBoundingBox.left >= scrollableDivBoundingBox.left &&
            elementBoundingBox.right <= scrollableDivBoundingBox.right &&
            elementBoundingBox.top >= scrollableDivBoundingBox.top &&
            elementBoundingBox.bottom <= scrollableDivBoundingBox.bottom
        );
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["per-slide-stores"] && !Shopify.designMode) return;
  try {
    
    (function($){
        $('ul.stores.enable_slide').slick({
            infinite: true,
            autoplay: false,
            autoplaySpeed: 1000 * 5,
            slidesToShow: 4,
            slidesToScroll: 4,
            speed: 500,
            arrows: true,
            prevArrow: '.per-slide-stores .slider-button--prev',
            nextArrow: '.per-slide-stores .slider-button--next',
            dots: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    })(jQuery.noConflict());

  } catch(e) { console.error(e); }
})();
})();
